import React from 'react';
import style from '../../style.module.scss';
import { LiveClassesList } from '../../../organisms/live_classes_list';
import { useYourClassesContext } from '../../context';
import { pluralize } from 'utilities/pluralize';
import { Icon } from '../../../assets/icons';
import { DateBox } from '../../../lib/DateBox';
import moment from 'moment';

export const UpcomingContent: React.FC = () => {
  const { data, fetchData } = useYourClassesContext();

  React.useEffect(() => {
    fetchData('upcoming');
    const intervalId = setInterval(() => {
      fetchData('upcoming', true);
    }, 1000 * 60);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <LiveClassesList
        icon={<DateBox moment={moment()} variant="secondary" />}
        title="Live Classes This Week"
        description={pluralize(data.upcoming.thisWeek.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.thisWeek}
      />

      <LiveClassesList
        icon={<DateBox moment={moment().day(8)} variant="secondary" />}
        title="Live Classes Next Week"
        description={pluralize(data.upcoming.nextWeek.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.nextWeek}
      />
      <LiveClassesList
        icon={<Icon iconType="DateTime" fill={style.brandSecondary} />}
        title="All Future Live Classes"
        description={pluralize(data.upcoming.allFuture.length, 'Class', 'Classes')}
        liveClasses={data.upcoming.allFuture}
      />
    </>
  );
};

export default UpcomingContent;
